var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        height: "calc(100vh - 100px)",
        overflow: "scroll",
        padding: "10px"
      }
    },
    [
      _c(
        "div",
        [
          _c(
            "v-breadcrumbs",
            [
              _c(
                "v-icon",
                {
                  attrs: { slot: "divider", color: "#68718e" },
                  slot: "divider"
                },
                [_vm._v("play_arrow")]
              ),
              _vm._v(" "),
              _c("v-breadcrumbs-item", [
                _c("a", { on: { click: _vm.goBack } }, [
                  _c("span", { staticStyle: { color: "#515a75" } }, [
                    _vm._v(" Settings")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("v-breadcrumbs-item", [
                _c("span", { staticStyle: { color: "#515a75" } }, [
                  _vm._v("Knowledgebase Folder")
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loader
        ? _c(
            "div",
            { staticClass: "elc-card-main" },
            [
              _c(
                "v-card",
                { staticClass: "p-10" },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "", row: "" } },
                    [
                      _c("v-flex", { attrs: { xs10: "", md11: "" } }, [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              "font-weight": "500",
                              "font-size": "22px",
                              color: "#596363",
                              margin: "0",
                              "margin-top": "17px"
                            }
                          },
                          [
                            _vm._v(
                              "\n                        Knowledge Base Folder"
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        {
                          staticClass: "text-xs-right",
                          attrs: { xs2: "", md1: "" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "p-l-10 p-r-10" },
                            [
                              _c(
                                "v-tooltip",
                                { attrs: { bottom: "" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "elc-button-rounded",
                                      attrs: {
                                        slot: "activator",
                                        fab: "",
                                        small: ""
                                      },
                                      on: { click: _vm.addKBFolderDialog },
                                      slot: "activator"
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticStyle: { "margin-top": "-5px" },
                                          attrs: { dark: "" }
                                        },
                                        [_vm._v("add")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Add Folder")])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "p-t-16 p-b-16" },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticStyle: { "font-size": "18px" },
                              attrs: { xs8: "", md8: "" }
                            },
                            [
                              _vm._v(
                                "\n                        Name\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "text-xs-right p-r-10",
                              staticStyle: { "font-size": "17px" },
                              attrs: { xs4: "", md4: "" }
                            },
                            [
                              _vm._v(
                                "\n                        Actions\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { xs12: "" } }, [
                            _c(
                              "div",
                              { staticClass: "p-t-10 p-b-10" },
                              [
                                _c("v-treeview", {
                                  staticClass: "elc-treeview",
                                  attrs: {
                                    open: _vm.open,
                                    items: _vm.folderArr,
                                    "item-key": "name",
                                    "item-children": "childrenArr"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function(ref) {
                                        var item = ref.item
                                        var open = ref.open
                                        var leaf = ref.leaf
                                        return [
                                          !leaf
                                            ? _c("span", [
                                                _vm._v(
                                                  "  **" + _vm._s(item.name)
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          leaf
                                            ? _c(
                                                "v-card",
                                                {
                                                  staticStyle: {
                                                    height: "50px"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                        **" +
                                                      _vm._s(item.name) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    },
                                    {
                                      key: "prepend",
                                      fn: function(ref) {
                                        var item = ref.item
                                        var open = ref.open
                                        var leaf = ref.leaf
                                        return [
                                          _c("v-icon", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  open
                                                    ? "folder_open"
                                                    : "folder"
                                                ) +
                                                "\n                                    "
                                            )
                                          ])
                                        ]
                                      }
                                    },
                                    {
                                      key: "append",
                                      fn: function(ref) {
                                        var item = ref.item
                                        var open = ref.open
                                        var leaf = ref.leaf
                                        return [
                                          _c(
                                            "v-tooltip",
                                            {
                                              staticStyle: { padding: "0 5px" },
                                              attrs: {
                                                slot: "activator",
                                                bottom: ""
                                              },
                                              slot: "activator"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticStyle: {
                                                    "font-size": "16px"
                                                  },
                                                  attrs: {
                                                    slot: "activator",
                                                    small: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.addSubKBFolderDialog(
                                                        item
                                                      )
                                                    }
                                                  },
                                                  slot: "activator"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            add\n                                        "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [_vm._v("Add Folder")])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-tooltip",
                                            {
                                              staticStyle: { padding: "0 5px" },
                                              attrs: {
                                                slot: "activator",
                                                bottom: ""
                                              },
                                              slot: "activator"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticStyle: {
                                                    "font-size": "16px"
                                                  },
                                                  attrs: {
                                                    slot: "activator",
                                                    small: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.editKBFolderDialog(
                                                        item
                                                      )
                                                    }
                                                  },
                                                  slot: "activator"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s("edit") +
                                                      "\n                                        "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v("Edit Folder")
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-tooltip",
                                            {
                                              staticStyle: { padding: "0 5px" },
                                              attrs: {
                                                slot: "activator",
                                                bottom: "",
                                                disabled: !leaf
                                              },
                                              slot: "activator"
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticStyle: {
                                                    "font-size": "16px"
                                                  },
                                                  attrs: {
                                                    slot: "activator",
                                                    disabled: !leaf,
                                                    small: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.openDelDialog(item)
                                                    }
                                                  },
                                                  slot: "activator"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                            " +
                                                      _vm._s("delete") +
                                                      "\n                                        "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v("Delete Folder")
                                              ])
                                            ],
                                            1
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.tree,
                                    callback: function($$v) {
                                      _vm.tree = $$v
                                    },
                                    expression: "tree"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", width: "300px" },
          on: {
            keydown: function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
              ) {
                return null
              }
              _vm.KBFolderDialog = false
            }
          },
          model: {
            value: _vm.KBFolderDialog,
            callback: function($$v) {
              _vm.KBFolderDialog = $$v
            },
            expression: "KBFolderDialog"
          }
        },
        [
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c("v-card", [
                _c(
                  "div",
                  { staticClass: "p-10" },
                  [
                    _c(
                      "div",
                      { staticStyle: { position: "relative" } },
                      [
                        !_vm.addEditFlag
                          ? _c("h2", { staticClass: "p-10" }, [
                              _vm._v("Add Folder ")
                            ])
                          : _c("h2", { staticClass: "p-10" }, [
                              _vm._v("Update Folder ")
                            ]),
                        _vm._v(" "),
                        _c(
                          "v-tooltip",
                          {
                            staticStyle: {
                              position: "absolute",
                              top: "0",
                              right: "0"
                            },
                            attrs: { bottom: "" }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { slot: "activator", icon: "" },
                                on: {
                                  click: function($event) {
                                    _vm.KBFolderDialog = false
                                  }
                                },
                                slot: "activator"
                              },
                              [_c("v-icon", [_vm._v("clear")])],
                              1
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("Close")])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-layout",
                      { attrs: { wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          { staticClass: "p-10", attrs: { xs12: "" } },
                          [
                            _vm.KBFolderDialog
                              ? _c("v-text-field", {
                                  attrs: {
                                    rules: _vm.fieldRules,
                                    label: "Name*",
                                    autofocus: "",
                                    required: ""
                                  },
                                  model: {
                                    value: _vm.folder.name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.folder, "name", $$v)
                                    },
                                    expression: "folder.name"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { staticClass: "text-sm-right", attrs: { xs12: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "elc-button-radius",
                            on: {
                              click: function($event) {
                                _vm.KBFolderDialog = false
                              }
                            }
                          },
                          [_vm._v("Cancel")]
                        ),
                        _vm._v(" "),
                        !_vm.addEditFlag
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "elc-button-radius-color",
                                attrs: {
                                  disabled: _vm.folder.name === "" || !_vm.valid
                                },
                                on: {
                                  click: function($event) {
                                    _vm.addFolder(_vm.folderData)
                                  }
                                }
                              },
                              [_vm._v("Save\n                        ")]
                            )
                          : _c(
                              "v-btn",
                              {
                                staticClass: "elc-button-radius-color",
                                attrs: {
                                  disabled: _vm.folder.name === "" || !_vm.valid
                                },
                                on: { click: _vm.updateFolder }
                              },
                              [_vm._v("Update\n                        ")]
                            )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.loader ? _c("loader") : _vm._e(),
      _vm._v(" "),
      _c("alert-modal", {
        attrs: { alertMsg: _vm.msg, alertMsgDialog: _vm.alertDialog },
        on: {
          closeAlert: function($event) {
            _vm.alertDialog = false
          }
        }
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.delDialog,
            callback: function($$v) {
              _vm.delDialog = $$v
            },
            expression: "delDialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-text", [
                _vm._v("Are you sure you want to delete this folder?")
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "elc-button-radius",
                      attrs: { flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.delDialog = false
                        }
                      }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "elc-button-radius-color",
                      attrs: { flat: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.deleteFolder()
                        }
                      }
                    },
                    [_vm._v("OK")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1084c161", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1084c161","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings/KnowledgeBaseFolder.vue
// module id = null
// module chunks = 